<svg-icon
    name="info-circle"
    svgClass="info-circle"
    kendoTooltip
    [title]="title()"
    [ngStyle]="{ width: size(), height: size() }"
>
</svg-icon>
